<template>
    <LoadingComponent :props="loading" />
    <SmSidebarModalCreateComponent :props="addButton" />

    <div id="sidebar" @click.self="reset"
        class="fixed inset-0 z-50 bg-light/50 duration-500 transition-all invisible opacity-0">
        <div class="padding-t-modal shadow-component-modal w-full max-w-xl h-screen overflow-x-hidden thin-scrolling bg-white ms-auto ltr:translate-x-full rtl:-translate-x-full">
        <div class="drawer-header padding-top">
            <h3 class="drawer-title">{{ $t('menu.product_sections') }}</h3>
            <button class="fa-solid fa-xmark close-btn" @click="reset"></button>
        </div>
        <div class="drawer-body">
            <form @submit.prevent="save">
                <div class="form-row">
                    <div class="form-col-12 sm:form-col-6">
                        <label for="name" class="db-field-title required">{{ $t("label.name") }}</label>
                        <input v-model="props.form.name" v-bind:class="errors.name ? 'invalid' : ''" type="text" id="name"
                            class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.name">{{
                            errors.name[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label class="db-field-title required">{{ $t("label.status") }}</label>
                        <div class="db-field-radio-group">
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" v-model="props.form.status" id="active"
                                        :value="enums.statusEnum.ACTIVE" class="custom-radio-field" checked />
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="active" class="db-field-label">{{
                                    $t("label.active")
                                }}</label>
                            </div>
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" class="custom-radio-field" v-model="props.form.status" id="inactive"
                                        :value="enums.statusEnum.INACTIVE" />
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="inactive" class="db-field-label">{{
                                    $t("label.inactive")
                                }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="limit" class="db-field-title required">Productos en Home (Previsualización)</label>
                        <input v-model="props.form.limit" v-bind:class="errors.limit ? 'invalid' : ''" type="number" id="limit" min="1" max="50" class="db-field-control" />
                        <div class="flex flex-wrap gap-1 mt-1.5">
                            <button type="button" v-for="preset in [4, 6, 8, 10, 12]" :key="preset"
                                @click="props.form.limit = preset"
                                class="px-2 py-0.5 text-xs rounded border transition-all duration-200"
                                :class="Number(props.form.limit) === preset ? 'bg-primary text-white border-primary' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
                                {{ preset }}
                            </button>
                        </div>
                        <small class="db-field-alert" v-if="errors.limit">{{ errors.limit[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label class="db-field-title required">Mostrar botón "Ver todo"</label>
                        <div class="db-field-radio-group">
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" v-model="props.form.show_view_all" id="show_view_all_yes"
                                        :value="enums.askEnum.YES" class="custom-radio-field" />
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="show_view_all_yes" class="db-field-label">{{ $t("label.yes") }}</label>
                            </div>
                            <div class="db-field-radio">
                                <div class="custom-radio">
                                    <input type="radio" class="custom-radio-field" v-model="props.form.show_view_all" id="show_view_all_no"
                                        :value="enums.askEnum.NO" />
                                    <span class="custom-radio-span"></span>
                                </div>
                                <label for="show_view_all_no" class="db-field-label">{{ $t("label.no") }}</label>
                            </div>
                        </div>
                        <small class="db-field-alert" v-if="errors.show_view_all">{{ errors.show_view_all[0] }}</small>
                    </div>

                    <div class="form-col-12">
                        <div class="flex flex-wrap gap-3 mt-4">
                            <button type="submit" class="db-btn py-2 text-white bg-primary">
                                <i class="lab lab-fill-save"></i>
                                <span>{{ $t("label.save") }}</span>
                            </button>

                            <button type="button" class="modal-btn-outline modal-close" @click="reset">
                                <i class="lab lab-fill-close-circle"></i>
                                <span>{{ $t("button.close") }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        </div>
    </div>
</template>
<script>
import SmSidebarModalCreateComponent from "../components/buttons/SmSidebarModalCreateComponent";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import LoadingComponent from "../components/LoadingComponent";
import statusEnum from "../../../enums/modules/statusEnum";
import askEnum from "../../../enums/modules/askEnum";
import alertService from "../../../services/alertService";
import appService from "../../../services/appService";
import { useCanvas } from "../../../composables/canvas";

export default {
    name: "ProductSectionCreateComponent",
    components: { SmSidebarModalCreateComponent, LoadingComponent, Datepicker },
    props: ["props"],
    data() {
        return {
            loading: {
                isActive: false,
            },
            enums: {
                statusEnum: statusEnum,
                statusEnumArray: {
                    [statusEnum.ACTIVE]: this.$t("label.active"),
                    [statusEnum.INACTIVE]: this.$t("label.inactive"),
                },
                askEnum: askEnum,
                askEnumArray: {
                    [askEnum.YES]: this.$t("label.yes"),
                    [askEnum.NO]: this.$t("label.no"),
                },
            },
            errors: {},
        };
    },
    computed: {
        addButton: function () {
              return {title: this.$t("button.add_product_section")}
        }
    },
    methods: {
        floatNumber(e) {
            return appService.floatNumber(e);
        },
        reset: function () {
            useCanvas().closeCanvas('sidebar');
            this.$store.dispatch("productSection/reset").then().catch();
            this.errors = {};
            this.$props.props.form = {
                name: "",
                status: statusEnum.ACTIVE,
                limit: 8,
                show_view_all: askEnum.YES,
            };
        },

        save: function () {
            try {
                const tempId = this.$store.getters["productSection/temp"].temp_id;
                this.loading.isActive = true;
                this.$store
                    .dispatch("productSection/save", {
                        form: this.props.form,
                        search: this.props.search,
                    })
                    .then((res) => {
                        useCanvas().closeCanvas('sidebar');
                        this.loading.isActive = false;
                        alertService.successFlip(
                            tempId === null ? 0 : 1,
                            this.$t("menu.product_sections")
                        );
                        this.props.form = {
                            name: "",
                            status: statusEnum.ACTIVE,
                            limit: 8,
                            show_view_all: askEnum.YES,
                        };
                        this.errors = {};
                    })
                    .catch((err) => {
                        this.loading.isActive = false;
                        this.errors = err.response.data.errors;
                    });
            } catch (err) {
                this.loading.isActive = false;
                alertService.error(err);
            }
        },
    },
};
</script>
